import React from "react";
import styles from "./styles.module.scss";

export const Loading = () => {
	return (
		<div className={styles.loading}>
			<svg width="101px" height="101px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
				<circle cx="50" cy="50" r="0" fill="none" stroke="#506ca7" strokeWidth="3">
					<animate
						attributeName="r"
						repeatCount="indefinite"
						dur="1s"
						values="0;40"
						keyTimes="0;1"
						keySplines="0 0.2 0.8 1"
						calcMode="spline"
						begin="-0.5s"
					></animate>
					<animate
						attributeName="opacity"
						repeatCount="indefinite"
						dur="1s"
						values="1;0"
						keyTimes="0;1"
						keySplines="0.2 0 0.8 1"
						calcMode="spline"
						begin="-0.5s"
					></animate>
				</circle>
				<circle cx="50" cy="50" r="0" fill="none" stroke="#f8ce60" strokeWidth="3">
					<animate
						attributeName="r"
						repeatCount="indefinite"
						dur="1s"
						values="0;40"
						keyTimes="0;1"
						keySplines="0 0.2 0.8 1"
						calcMode="spline"
					></animate>
					<animate
						attributeName="opacity"
						repeatCount="indefinite"
						dur="1s"
						values="1;0"
						keyTimes="0;1"
						keySplines="0.2 0 0.8 1"
						calcMode="spline"
					></animate>
				</circle>
			</svg>
		</div>
	);
};
